import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-logifit-menu-row',
  standalone: true,
  imports: [IonicModule],
  templateUrl: './logifit-menu-row.component.html',
  styleUrls: ['./logifit-menu-row.component.scss']
})
export class LogifitMenuRowComponent {
  @Input() icon = '';
  @Input() label = '';
  @Input() triggerId?: string;

  @Output() rowClick = new EventEmitter<void>();
}
